import { render, staticRenderFns } from "./RemoveDiscount.vue?vue&type=template&id=4410e870&lang=pug"
import script from "./RemoveDiscount.vue?vue&type=script&lang=js"
export * from "./RemoveDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports